"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscreteStatus = exports.DiscreteStrategy = void 0;
var DiscreteStrategy;
(function (DiscreteStrategy) {
    DiscreteStrategy["FLAT"] = "FLAT";
    DiscreteStrategy["LINEAR"] = "LINEAR";
    DiscreteStrategy["EXPONENTIAL"] = "EXPONENTIAL";
})(DiscreteStrategy || (exports.DiscreteStrategy = DiscreteStrategy = {}));
var DiscreteStatus;
(function (DiscreteStatus) {
    DiscreteStatus["ACTIVE"] = "ACTIVE";
    DiscreteStatus["INACTIVE"] = "INACTIVE";
})(DiscreteStatus || (exports.DiscreteStatus = DiscreteStatus = {}));
//# sourceMappingURL=discrete.js.map